import { useState } from 'react'

import { BordersStyles, Box, Button } from '@factorialco/deprecated-design-system'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onEmployeeSelected: (employeeId: string) => void
  onDiscard: () => void
}

const EmployeeAssigner = ({ onEmployeeSelected, onDiscard }: Props) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | undefined>(undefined)

  const border: BordersStyles = {
    bottom: {
      width: 's1',
      style: 'solid',
      color: 'grey400',
    },
  }

  const onSelect = () => {
    if (selectedEmployeeId) {
      onEmployeeSelected(selectedEmployeeId)
    }
  }

  return (
    <Box flexDirection="column" style={{ width: '100%' }} border={border} background="grey100">
      <Box style={{ width: '100%' }}>
        <EmployeeSelectorV2
          value={selectedEmployeeId}
          onChange={setSelectedEmployeeId}
          options={{ asList: true, hideLabel: true }}
        />
      </Box>
      <Box
        alignItems="flexEnd"
        style={{ width: '100%' }}
        background="grey100"
        paddingX="s16"
        paddingY="s12"
        gap="s12"
        justifyContent="spaceBetween"
      >
        <Box paddingLeft="s8">
          <Box flexDirection="row" gap="s8">
            <Button type="primary" onClick={onSelect}>
              {i18n.t('split_documents.workflow_payslips.employee_assigner.select_employee')}
            </Button>
            <Button type="secondary" onClick={onDiscard} iconName="delete" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmployeeAssigner
